import React, { Dispatch, PropsWithChildren, SetStateAction, createContext, useEffect, useMemo, useState } from 'react';

import { DocumentResult } from '@amzn/coral_com-amazon-musicpaperrecordkeeperservice';

import { IndexMetadata } from 'src/components/Agreements';
import { SearchIndex } from 'src/util/search-index';

export interface ISearchContext {
    tableFilters: TableFilters;
    setTableFilters: Dispatch<SetStateAction<TableFilters>>;
    searchResults: DocumentResult[] | undefined;
    setSearchResults: Dispatch<SetStateAction<DocumentResult[] | undefined>>;
    searchIndex: SearchIndex<IndexMetadata>;
    setSearchIndex: Dispatch<SetStateAction<SearchIndex<IndexMetadata>>>;
}

export const DEFAULT_SEARCH_CONTEXT: ISearchContext = {
    tableFilters: {},
    setTableFilters: () => {},
    searchResults: undefined,
    setSearchResults: () => {},
    searchIndex: new SearchIndex([]),
    setSearchIndex: () => {}
};

export const SearchContext = createContext<ISearchContext>(DEFAULT_SEARCH_CONTEXT);

export interface TableFilters {
    [dataType: string]: string[] | undefined;
}

export const SearchContextProvider: React.FC<PropsWithChildren> = (props) => {
    const [tableFilters, setTableFilters] = useState<TableFilters>({});
    const [searchResults, setSearchResults] = useState<DocumentResult[] | undefined>();
    const [searchIndex, setSearchIndex] = useState(new SearchIndex<IndexMetadata>([]));

    return (
        <SearchContext.Provider
            value={{
                tableFilters,
                setTableFilters,
                searchResults,
                setSearchResults,
                searchIndex,
                setSearchIndex
            }}
        >
            {props.children}
        </SearchContext.Provider>
    );
};
